import { createColumnHelper, CellContext } from "@tanstack/react-table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Loading from "../../../cross/Loading";
import { EnumEstadoAuditoria } from "../../../entities/helper/EnumEstadoAuditoria";
import { EnumTipoDocumentoAuditoria } from "../../../entities/helper/EnumTipoDocumentoAuditoria";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import IAuditoria from "../../../entities/IAuditoria";
import IDocumentoAuditoria from "../../../entities/IDocumentoAuditoria";
import IHallazgos from "../../../entities/IHallazgos";
import { IItemNormativaxAuditoria } from "../../../entities/IItemNormativaxAuditoria";
import IItemNormativo from "../../../entities/IItemNormativo";
import { dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { deleteAPI, getAPI, postAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserToken, cognitoUserInfo } from "../../../helpers/userHelper";
import {
  ROW_COUNT,
  API_AUDITORIA,
  API_AUDITORIA_GET_AUDITORIA,
  ROW_COUNT_MAX,
  API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA,
  API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA,
  API_AUDITORIA_POST_AUDITORIA,
  API_AUDITORIA_GET_HALLAZGOSXAUDITORIA,
  API_AUDITORIA_GET_DOCUMENTOSAUDITORIA,
  API_AUDITORIA_DELETE_DOCUMENTOSAUDITORIA,
  API_AUDITORIA_POST_DOCUMENTOSAUDITORIA,
  API_AUDITORIA_GET_VALIDATIONEXISTHALLAZGOXITEMNORMATIVA,
  API_AUDITORIA_POST_RECHAZARAUDITORIA,
  API_AUDITORIA_POST_VALIDARAUDITORIA,
} from "../../../helpers/variableHelper";
import AdminLista from "../../administration/AdminLista";
import DetallePlanAuditoria from "./DetallePlanAuditoria";
import FormItemNormativa from "./FormItemNormativa";
import { getFileName } from "../../../helpers/pathHelper";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AuditoriaService from "../../../services/AuditoriaService";
import IItemNormativoActive from "../../../entities/IItemNormativoActive";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
const MySwal = withReactContent(Swal);
interface IDetalleInformeAuditoriaProps {
  loading?: boolean;
  items?: Array<IItemNormativaxAuditoria>;
  itemsDoc?: Array<IDocumentoAuditoria>;
  isEditTest?: boolean;
  isPopUpTest?: boolean;
}

export default function DetalleInformeAuditoria({ loading = true, items, itemsDoc, isEditTest, isPopUpTest }: IDetalleInformeAuditoriaProps) {
  // NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de propiedades en la carga del informe de auditoría
  let search = new URLSearchParams(window.location.search);
  const idAuditoria = parseInt(search.get("id") || "0");
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(loading);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const [isDeletingDocs, setIsDeletingDocs] = useState(false);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [pages, setPages] = useState(0);
  const [pagesDocsAuditoria, setPagesDocsAuditoria] = useState(0);
  const [page, setPage] = useState(1);
  const [pageDocsAuditoria] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [pageSizeDocsAuditoria, setPageSizeDocsAuditoria] = useState(ROW_COUNT);
  const [isEdit, setIsEdit] = useState(isEditTest || false);
  const [auditoriaSeleccionada, setAuditoriaSeleccionada] = useState<IAuditoria>();
  const [isDownloading, setIsDownloading] = useState(false);

  const [itemNormativaAuditoria, setItemNormativaAuditoria] = useState<Array<IItemNormativaxAuditoria> | null>(items || null);
  const [documentosAuditoria, setDocumentosAuditoria] = useState<Array<IDocumentoAuditoria>>(itemsDoc || []);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [arrErrorEmptyFile, setArrErrorEmptyFile] = useState<Array<string>>([]);
  const [isOpenModalItemNormativo, setIsOpenModalItemNormativo] = useState(isPopUpTest || false);
  const [contadorCaracterTxtConclusion, setContadorCaracterTxtConclusion] = useState(0);
  const [contadorCaracterTxtDescripcion, setContadorCaracterTxtDescripcion] = useState(0);
  const [selectedItemNormativo, setSelectedItemNormativo] = useState<IItemNormativo | null>(null);

  const [selectedItemNormativoList, setSelectedItemNormativoList] = useState<IItemNormativoActive | null>(null);
  const refTxtFechaReuInicial = React.createRef<HTMLInputElement>();
  const refTxtFechaReuFinal = React.createRef<HTMLInputElement>();
  const refTxtFechaInforme = React.createRef<HTMLInputElement>();
  const refTxtConclusion = React.createRef<HTMLTextAreaElement>();
  const refTxtDescripcion = React.createRef<HTMLTextAreaElement>();
  const refInputFile = React.createRef<HTMLInputElement>();
  let paramsActive = {
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
    ORDENADOPOR: `ID`,
    ORIENTACION: "DESC",
    ACTIVO: true,
  };
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const table = (info: any) => {
    return (
      <table className="table tablaTLC table-bordered table-primary table-sm">
        <thead>
          <tr>
            <th className="w-10">Tipo de Desviación</th>
            <th className="w-10">Ambito desviación</th>
            <th className="w-10">Potencialidad</th>
            <th>Problema</th>
            <th>Evidencia</th>
          </tr>
        </thead>
        <tbody>
          {info.getValue().map((h: any) => (
            <tr key={h.ID}>
              <td>{h.TIPO_DESVIACION}</td>
              <td>{h.AMBITO_DESVIACION}</td>
              <td>{h.POTENCIALIDAD}</td>
              <td>{h.PROBLEMA}</td>
              <td>{h.EVIDENCIA}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const div = (info: any) => {
    return <div>{info.getValue()?.length > 0 && table(info)}</div>;
  };
  const componentOpciones = (value: any) => {
    return (
      <i
        className="bi bi-pencil-square iconPencil text-decoration-none text-secondary"
        onClick={async (e) => {
          e.preventDefault();
          let flag = await saveData();
          if (flag) {
            window.location.href = `agregarhallazgos?idauditoria=${value.row.original.ID_AUDITORIA}&iditemnormativo=${
              value.row.original.ID
            }&txtitemnormativo=${encodeURI(value.row.original.ITEM_NORMATIVO)}`;
          }
        }}
      />
    );
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const renderVer = (value: any) => {
    return (
      <i
        className="bi bi-file-earmark-arrow-down-fill iconDescarga"
        onClick={async () => {
          setIsDownloading(true);
          await AuditoriaService.GetContenidoArchivo(token, value.URL);
          setIsDownloading(false);
        }}
      />
    );
  };

  const renderEliminar = (value: any, value2: any) => {
    return (
      <i
        className="bi bi-trash iconTrash"
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>Desea eliminar el documento {getFileName(value.URL)}</h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then((result) => {
            if (result.isConfirmed) {
              deleteDocumento(value2);
            }
          });
        }}
      />
    );
  };

  const esAuditorParticipante = (users: string | undefined, emailUser: string | undefined) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(true);

    let resultAuditoria: IAuditoria = isEditTest
      ? { CONCLUSIONES: "" }
      : (await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_AUDITORIA}`, { Authorization: `Bearer ${token}` }, { ID: idAuditoria })).result;
    setAuditoriaSeleccionada(resultAuditoria);
    setContadorCaracterTxtConclusion(resultAuditoria.CONCLUSIONES?.length || 0);
    setIsEdit(
      (resultAuditoria.ID_ESTADO === EnumEstadoAuditoria.PlanListo || resultAuditoria.ID_ESTADO === EnumEstadoAuditoria.InformeRechazado) &&
        (resultAuditoria.AUDITOR_LIDER.includes(currUser.email) || esAuditorParticipante(resultAuditoria.AUDITORES_ACOMPANANTES, currUser.email))
    );

    let resultItemNormativaAuditoria = isEditTest
      ? { data: [] }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            {
              ...paramsActive,
              PAGINADO: ROW_COUNT,
              ID_AUDITORIA: idAuditoria,
              ORDENADOPOR: `INO."ID"`,
            }
          )
        ).result;

    let resultHallazgos: Array<IHallazgos> = isEditTest
      ? { data: [] }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_HALLAZGOSXAUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            {
              ...paramsActive,
              ID: idAuditoria,
            }
          )
        ).result.data;
    let itemsNormativa: Array<IItemNormativaxAuditoria> = resultItemNormativaAuditoria.data;

    itemsNormativa.forEach((ino) => {
      ino.HALLAZGOS = resultHallazgos.filter((h) => h.ID_ITEM_NORMATIVO == ino.ID);
    });
    setItemNormativaAuditoria(itemsNormativa);
    setPages(resultItemNormativaAuditoria.pages);

    let resultDocumentosAuditoria = isEditTest
      ? { data: [], pages: 100 }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_DOCUMENTOSAUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            {
              ...paramsActive,
              PAGINADO: ROW_COUNT,
              ID_AUDITORIA: idAuditoria,
              ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
              ORDENADOPOR: `ID`,
            }
          )
        ).result;
    setDocumentosAuditoria(resultDocumentosAuditoria.data);
    setPagesDocsAuditoria(resultDocumentosAuditoria.pages);

    setIsLoading(false);
  }, []);

  useEffect(() => {
    let agregoHallazgo = sessionStorage.getItem("agregoHallazgo");
    let itemNormativoInforme = document.getElementById("itemNormativoInforme");
    if (!isLoading && itemNormativoInforme !== null && agregoHallazgo === "true") {
      itemNormativoInforme.scrollIntoView();
    }
  }, [isLoading]);

  const filter = async (filters: Partial<IItemNormativo>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = size;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = "ID";
      filters.ORIENTACION = "DESC";
    }

    let result = isEditTest
      ? { data: [], pages: 100 }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            { ...filters, ID_AUDITORIA: idAuditoria }
          )
        ).result;
    let resultHallazgos: Array<IHallazgos> = isEditTest
      ? []
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_HALLAZGOSXAUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            {
              ...paramsActive,
              ID: idAuditoria,
            }
          )
        ).result.data;
    let itemsNormativa: Array<IItemNormativaxAuditoria> = result.data;

    itemsNormativa.forEach((ino) => {
      ino.HALLAZGOS = resultHallazgos.filter((h) => h.ID_ITEM_NORMATIVO == ino.ID);
    });
    setItemNormativaAuditoria(itemsNormativa);
    let pages = result.pages;
    setPages(pages);
  };

  const formValidation = (value: Partial<IAuditoria>) => {
    let arrErrors: Array<string> = [];

    if (!value.FECHA_REUNION_INICIAL) {
      arrErrors.push("FECHA_REUNION_INICIAL");
      refTxtFechaReuInicial.current?.focus();
    }
    if (!value.FECHA_REUNION_FINAL) {
      arrErrors.push("FECHA_REUNION_FINAL");
      refTxtFechaReuFinal.current?.focus();
    }
    if (moment(value.FECHA_REUNION_INICIAL) > moment(value.FECHA_REUNION_FINAL)) {
      arrErrors.push("FECHA_REUNION_FINAL");
      refTxtFechaReuFinal.current?.focus();
      MySwal.fire({
        html: (
          <div>
            <h3>Fecha reunión inicial no puede ser mayor a la fecha reunión final.</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }
    if (!value.FECHA_INFORME) {
      arrErrors.push("FECHA_INFORME");
      refTxtFechaInforme.current?.focus();
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const saveData = async (btnContinuar?: boolean): Promise<boolean> => {
    let result = null;
    const value: Partial<IAuditoria> = {
      ...auditoriaSeleccionada,
      FECHA_REUNION_INICIAL: refTxtFechaReuInicial.current?.value,
      FECHA_REUNION_FINAL: refTxtFechaReuFinal.current?.value,
      FECHA_INFORME: refTxtFechaInforme.current?.value,
      EDITOR: currentUser?.email,
      EDITOR_DISPLAY: currentUser?.fullname,
      FECHA_MODIFICACION: new Date(),
      ID_ESTADO: auditoriaSeleccionada?.ID_ESTADO,
      CONCLUSIONES: refTxtConclusion.current?.value || auditoriaSeleccionada?.CONCLUSIONES,
    };

    if (formValidation(value)) {
      setIsSendingData(true);
      await postAPI(`${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA}`, value, { Authorization: `Bearer ${token}` });
      if (!btnContinuar) {
        setIsSendingData(false);
      }
      return true;
    } else {
      return false;
    }
  };

  const getRequisitos = (item: any) => {
    let value: number[] = [];

    item.forEach((a: any) => {
      a.REQUISITOS_NORMATIVOS.forEach((r: any) => {
        value.push(r);
      });
    });

    return value;
  };

  const columnHelperMantIncCausa = createColumnHelper<IItemNormativaxAuditoria>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.ITEM_NORMATIVO, {
      id: "ITEM_NORMATIVO",
      cell: (info: CellContext<IItemNormativaxAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Item Normativo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.PREDIO_RECINTO, {
      id: "PREDIO_RECINTO",
      cell: (info: CellContext<IItemNormativaxAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Predio/Recinto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA, {
      id: "FECHA",
      cell: (info: CellContext<IItemNormativaxAuditoria, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.HORA_INICIO, {
      id: "HORA_INICIO",
      cell: (info: CellContext<IItemNormativaxAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Hora Inicio"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.HORA_FINAL, {
      id: "HORA_FINAL",
      cell: (info: CellContext<IItemNormativaxAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Hora Final"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.HALLAZGOS, {
      id: "Observaciones",
      cell: (info: CellContext<IItemNormativaxAuditoria, Array<IHallazgos>>) => div(info),
      header: () => component("Hallazgos"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "OPCIONES",
      cell: (info: CellContext<IItemNormativaxAuditoria, string>) => componentOpciones(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      hide:
        auditoriaSeleccionada?.ID_ESTADO === EnumEstadoAuditoria.InformeListo ||
        auditoriaSeleccionada?.ID_ESTADO === EnumEstadoAuditoria.InformeCerrado ||
        auditoriaSeleccionada?.ID_ESTADO === EnumEstadoAuditoria.InformeCompletado ||
        auditoriaSeleccionada?.ID_ESTADO === EnumEstadoAuditoria.AuditoriaCerrada ||
        (auditoriaSeleccionada?.AUDITOR_LIDER !== currentUser?.email &&
          !esAuditorParticipante(auditoriaSeleccionada?.AUDITORES_ACOMPANANTES, currentUser?.email)),
    } as any),
  ] as any;

  const columnHelperDocumentos = createColumnHelper<IDocumentoAuditoria>();
  let columnsDefDocs = [
    columnHelperDocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoAuditoria, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((row) => row.URL, {
      id: "VER",
      cell: (info: CellContext<IDocumentoAuditoria, string>) => renderVer(info.row.original),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperDocumentos.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<IDocumentoAuditoria, number>) => renderEliminar(info.row.original, info.getValue()),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: !isEdit,
    } as any),
  ] as any;

  const filterDocumentos = async (filters: Partial<IDocumentoAuditoria>, page: boolean = false, size = pageSizeDocsAuditoria) => {
    if (!filters) {
      filters = { ...paramsActive };
    }
    filters.PAGINADO = size;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = "ID";
      filters.ORIENTACION = "DESC";
    }

    let resultDocumentosAuditoria = isEditTest
      ? { data: [], pages: 100 }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_DOCUMENTOSAUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            {
              ...filters,
              PAGINADO: ROW_COUNT,
              ID_AUDITORIA: idAuditoria,
              ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
            }
          )
        ).result;
    setDocumentosAuditoria(resultDocumentosAuditoria.data);
    setPagesDocsAuditoria(resultDocumentosAuditoria.pages);
  };

  const deleteDocumento = async (id: number) => {
    const url = `${API_AUDITORIA}${API_AUDITORIA_DELETE_DOCUMENTOSAUDITORIA}`;
    await deleteAPI(
      url,
      { Authorization: `Bearer ${token}` },
      {
        ID: id,
      }
    );
    setIsDeletingDocs(true);
    await filterDocumentos({});
    setIsDeletingDocs(false);
    sessionStorage.setItem("agregoHallazgo", "false");
  };
  const validateUploadFile = (value: Partial<IDocumentoAuditoria>) => {
    let arrErrors: Array<string> = [];

    console.log(refInputFile.current?.files);
    if (refInputFile.current?.files?.length === 0) {
      arrErrors.push("ARCHIVO");
      MySwal.fire({
        html: (
          <div>
            <h3>Seleccione un archivo</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    } else if (
      refInputFile.current?.files !== undefined &&
      refInputFile.current?.files !== null &&
      documentosAuditoria.filter((d) => d.URL.includes((refInputFile.current?.files as FileList)[0].name)).length > 0
    ) {
      arrErrors.push("ARCHIVO_DUPLICADO");

      MySwal.fire({
        html: (
          <div>
            <h3>Archivo "{(refInputFile.current?.files)[0].name}" ya se encuentra cargado</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmptyFile(arrErrors);
    return arrErrors.length === 0;
  };
  const handleUploadFile = async () => {
    let f = isEditTest ? {} : ((refInputFile.current?.files as FileList)[0] as any);
    let value: Partial<IDocumentoAuditoria> = {
      ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
      ID_AUDITORIA: idAuditoria,
      ID_PROGRAMA: auditoriaSeleccionada?.ID_PROGRAMA_AUDITORIA || 0,
      DESCRIPCION: refTxtDescripcion.current?.value,
      FILE: f,
    };
    if (validateUploadFile(value)) {
      setIsSendingData(true);
      setIsUploadingDocs(true);
      await uploadFile(value);
      setContadorCaracterTxtDescripcion(0);
      setIsSendingData(false);
      setIsUploadingDocs(false);
      let txtDescripcion = document.getElementById("refTxtDescripcion") as HTMLTextAreaElement;
      if (txtDescripcion !== null) txtDescripcion.value = "";
      let inputFile = document.getElementById("refInputFile") as HTMLInputElement;
      if (inputFile !== null) inputFile.value = "";
    }
    sessionStorage.setItem("agregoHallazgo", "false");
  };
  const uploadFile = async (value: Partial<IDocumentoAuditoria>) => {
    const url = `${API_AUDITORIA}${API_AUDITORIA_POST_DOCUMENTOSAUDITORIA}`;
    const formData = new FormData();
    formData.append("ID_TIPO_DOCUMENTO", value.ID_TIPO_DOCUMENTO?.toString() || "");
    formData.append("ID_AUDITORIA", value.ID_AUDITORIA?.toString() || "");
    formData.append("DESCRIPCION", value.DESCRIPCION as string);
    formData.append("ID_PROGRAMA", value.ID_AUDITORIA?.toString() || "");
    formData.append("FILE", value.FILE);
    delete value.FILE;
    await postAPI(url, formData, { Authorization: `Bearer ${token}` }, value);
    await filterDocumentos({});
  };
  const validateBtnContinuar = async (value: Partial<IAuditoria>) => {
    let arrErrors: Array<string> = [];

    if (!value.CONCLUSIONES) {
      arrErrors.push("CONCLUSIONES");
    }

    let flag = await validarHallazgosEnItemNormativa();
    if (!flag) {
      arrErrors.push("HALLAZGOS_ITEM_NORMATIVO");
    }

    if (documentosAuditoria.length < 2) {
      arrErrors.push("DOCUMENTACION_ACTA");
    }

    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            {!flag && <h4>Todos los Ítem Normativos deben poseer Hallazgos</h4>}
            {documentosAuditoria.length < 2 && <h4>Debe adjuntar la documentación requerida(acta inicial y acta final).</h4>}
            {!value.CONCLUSIONES && <h4>Debe ingresar la conclusión</h4>}
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors;
  };
  const handleBtnContinuar = async () => {
    let value: Partial<IAuditoria> = {
      CONCLUSIONES: refTxtConclusion.current?.value,
    };

    let validation = await validateBtnContinuar(value);

    if (!validation.includes("CONCLUSIONES")) {
      await saveData(validation.length === 0);
    }
    if (validation.length === 0) {
      setIsSendingData(true);
      await postAPI(
        `${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA}`,
        {
          ID: idAuditoria,
          EDITOR: currentUser?.email,
          EDITOR_DISPLAY: currentUser?.fullname,
          FECHA_MODIFICACION: new Date(),
          ENVIAR_NOTIFICACION: true,
          RESPONSABLE_AREA: auditoriaSeleccionada?.RESPONSABLE_AREA,
          RESPONSABLE_AREA_DISPLAY: auditoriaSeleccionada?.RESPONSABLE_AREA_DISPLAY,
          AUDITOR_LIDER: auditoriaSeleccionada?.AUDITOR_LIDER,
          AUDITOR_LIDER_DISPLAY: auditoriaSeleccionada?.AUDITOR_LIDER_DISPLAY,
          AUDITORES_ACOMPANANTES: auditoriaSeleccionada?.AUDITORES_ACOMPANANTES,
          AUDITORES_ACOMPANANTES_DISPLAY: auditoriaSeleccionada?.AUDITORES_ACOMPANANTES_DISPLAY,
        },
        { Authorization: `Bearer ${token}` }
      );

      AuditoriaService.GenerarPDFInforme(token, idAuditoria);
      setTimeout(() => {
        window.location.href = "/auditoria/home";
      }, 2000);
    }
  };

  const validarHallazgosEnItemNormativa = async (): Promise<boolean> => {
    let result = isEditTest
      ? { result: { data: [] } }
      : await getAPI(
          `${API_AUDITORIA}${API_AUDITORIA_GET_VALIDATIONEXISTHALLAZGOXITEMNORMATIVA}`,
          { Authorization: `Bearer ${token}` },
          {
            ID_AUDITORIA: idAuditoria,
          }
        );

    let flag = result.result.data;
    return flag;
  };

  const aprobacionAuditoria = async (flag: boolean, motivo?: string) => {
    setIsSendingData(true);
    await postAPI(
      `${API_AUDITORIA}${flag ? API_AUDITORIA_POST_VALIDARAUDITORIA : API_AUDITORIA_POST_RECHAZARAUDITORIA}`,
      {
        ID: idAuditoria,
        EDITOR: currentUser?.email,
        EDITOR_DISPLAY: currentUser?.fullname,
        FECHA_MODIFICACION: new Date(),
        MOTIVO: motivo,
      },
      { Authorization: `Bearer ${token}` }
    );
    AuditoriaService.GenerarPDFInforme(token, idAuditoria);
    setTimeout(() => {
      window.location.href = "/auditoria/home";
    }, 3000);
  };

  return (
    <div>
      <button
        data-testid="btneditinforme"
        hidden={true}
        onClick={() => {
          formValidation({});
          handleBtnContinuar();
          validarHallazgosEnItemNormativa();
          aprobacionAuditoria(true, "");
          validateBtnContinuar({});
          handleUploadFile();
          validateUploadFile({});
          deleteDocumento(1);
          saveData(true);
          saveData(false);
          uploadFile({} as Partial<IDocumentoAuditoria>);
        }}></button>
      {isDownloading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <DetallePlanAuditoria readonly={true} />
          <div className="row">
            <div className="col-12">
              <div className="rounded bg-white p-2 shadow">
                <div className="container-fluid mb-4">
                  <div className="card bg-light border p-3 pt-2 mt-2">
                    <div className="row ajusteInput">
                      <div className="col-12">
                        <h6>
                          <span className="textSeccion">Informe Auditoría</span>
                        </h6>
                      </div>

                      <div className="col-sm-12 col-md-4 col-lg-3">
                        <label className="me-2">
                          <span className="text-danger">(*)</span> Fecha Reunión Inicial{" "}
                        </label>
                        <input
                          className={`${arrErrorEmpty.includes("FECHA_REUNION_INICIAL") && "error"} text-secondary border border-secondary`}
                          type="date"
                          ref={refTxtFechaReuInicial}
                          defaultValue={moment(auditoriaSeleccionada?.FECHA_REUNION_INICIAL).format("yyyy-MM-DD") || ""}
                          disabled={!isEdit}
                        />
                      </div>
                      <div className="col-sm-12 col-md-4 col-lg-3">
                        <label className="me-2">
                          <span className="text-danger">(*)</span> Fecha Reunión Final
                        </label>
                        <input
                          className={`${arrErrorEmpty.includes("FECHA_REUNION_FINAL") && "error"} text-secondary border border-secondary`}
                          type="date"
                          ref={refTxtFechaReuFinal}
                          defaultValue={moment(auditoriaSeleccionada?.FECHA_REUNION_FINAL).format("yyyy-MM-DD") || ""}
                          disabled={!isEdit}
                        />
                      </div>
                      <div className="col-sm-12 col-md-4 col-lg-3">
                        <label className="me-2">
                          <span className="text-danger">(*)</span> Fecha Informe
                        </label>
                        <input
                          className={`${arrErrorEmpty.includes("FECHA_INFORME") && "error"} text-secondary border border-secondary`}
                          type="date"
                          ref={refTxtFechaInforme}
                          defaultValue={moment(auditoriaSeleccionada?.FECHA_INFORME).format("yyyy-MM-DD") || ""}
                          disabled={!isEdit}
                          max={moment().format(dateFormatInputReference)}
                        />
                      </div>
                      <div className="col-sm-12 col-md-4 col-lg-3"></div>
                    </div>
                  </div>
                  {isOpenModalItemNormativo && (
                    <FormItemNormativa
                      isOpen={isOpenModalItemNormativo}
                      idAuditoria={idAuditoria}
                      createdItemNormativo={selectedItemNormativoList}
                      callBack={() => {
                        filter({});
                        setIsOpenModalItemNormativo(false);
                        setSelectedItemNormativo(null);
                        setSelectedItemNormativoList(null);
                      }}
                      callBackClose={() => {
                        setIsOpenModalItemNormativo(false);
                        setSelectedItemNormativo(null);
                        setSelectedItemNormativoList(null);
                      }}
                      selectedItemNormativo={selectedItemNormativo || null}
                    />
                  )}
                  {isEdit && (
                    <div id="itemNormativoInforme" className="row">
                      <div className="col-sm-6 col-md-6 col-lg-12 pt-0">
                        <button
                          data-testid="test1"
                          type="button"
                          className="btn btn-sm btn-primary float-end mt-2"
                          onClick={async () => {
                            let flag = await saveData();
                            if (flag) {
                              setIsOpenModalItemNormativo(true);
                              setSelectedItemNormativo(null);
                              setSelectedItemNormativoList({ REQUISITOS_NORMATIVOS: getRequisitos(itemNormativaAuditoria) as any });
                              sessionStorage.setItem("agregoHallazgo", "false");
                            }
                          }}>
                          <i className="bi bi-plus-circle me-2"></i> Agregar Ítem Normativo
                        </button>
                      </div>
                    </div>
                  )}
                  <AdminLista
                    hideAdd={true}
                    hideExport={true}
                    data={itemNormativaAuditoria || []}
                    callback={() => {}}
                    reload={filter}
                    filter={filter}
                    pagination={{
                      pages: pages,
                      page: page,
                      paging: filter,
                    }}
                    tipo="Programaciones"
                    columnsDef={columnsDef}
                    callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                      setPageSize(pageSize);
                      filter(filters, false, pageSize);
                    }}
                  />

                  <div className="card bg-light border p-3 pt-2 mt-2">
                    <div className="row ajusteInput">
                      <div className="col-12">
                        <h6>
                          <span className="textSeccion">
                            {isEdit && <span className="text-danger">(*)</span>} {isEdit ? "Adjuntar Documento" : "Documentos"}
                          </span>
                        </h6>
                      </div>
                      {isEdit && (
                        <span>
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <label>Descripción</label>
                            <div className="mb-2">
                              <textarea
                                id="refTxtDescripcion"
                                className={`form-control form-control-sm w-50 ${arrErrorEmptyFile.includes("DESCRIPCION") && "error"}`}
                                data-testId="textbox"
                                rows={3}
                                ref={refTxtDescripcion}
                                onChange={() => setContadorCaracterTxtDescripcion(refTxtDescripcion.current?.value.length || 0)}
                                maxLength={250}></textarea>

                              <span>{contadorCaracterTxtDescripcion}/250</span>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <span className="text-danger">(*)</span>
                            <label>Subir Archivo</label>
                            <div className="mb-2">
                              <div className="input-group">
                                <input
                                  id="refInputFile"
                                  className={`form-control form-control-sm w-50 ${arrErrorEmptyFile.includes("ARCHIVO") && "error"}`}
                                  ref={refInputFile}
                                  type="file"
                                />
                                {isUploadingDocs ? (
                                  <Loading />
                                ) : (
                                  <button className="btn btn-sm btn-primary" disabled={isSendingData} onClick={() => handleUploadFile()}>
                                    Subir
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </span>
                      )}
                      <div className="col-12">
                        {isDeletingDocs && <Loading />}
                        <AdminLista
                          hideAdd={true}
                          hideExport={true}
                          data={documentosAuditoria || []}
                          callback={() => {}}
                          reload={filterDocumentos}
                          filter={filterDocumentos}
                          pagination={{
                            pages: pagesDocsAuditoria,
                            page: pageDocsAuditoria,
                            paging: filterDocumentos,
                          }}
                          tipo="Programaciones"
                          columnsDef={columnsDefDocs}
                          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                            setPageSizeDocsAuditoria(pageSize);
                            filterDocumentos(filters, false, pageSize);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="card bg-light border p-3 pt-2 mt-2">
                    <div className="row ajusteInput">
                      <div className="col-12">
                        <h6>
                          <span className="textSeccion">{isEdit && <span className="text-danger">(*)</span>} Conclusiones</span>
                        </h6>
                      </div>
                      <div className="col-12">
                        <textarea
                          className={`form-control form-control-sm ${arrErrorEmpty.includes("CONCLUSIONES") && "error"}`}
                          rows={3}
                          data-testId="textbox2"
                          ref={refTxtConclusion}
                          onChange={() => setContadorCaracterTxtConclusion(refTxtConclusion.current?.value.length || 0)}
                          maxLength={1000}
                          disabled={!isEdit}
                          defaultValue={auditoriaSeleccionada?.CONCLUSIONES}></textarea>

                        <span hidden={!isEdit}>{contadorCaracterTxtConclusion}/1000</span>
                      </div>
                    </div>
                  </div>
                  {auditoriaSeleccionada?.RECHAZO && (
                    <div className="card bg-light border p-3 pt-2 mt-2">
                      <div className="row ajusteInput">
                        <div className="col-12">
                          <h6>
                            <span className="textSeccion">Motivo Rechazo</span>
                          </h6>
                        </div>
                        <div className="col-12">
                          <textarea
                            className={`form-control form-control-sm w-50`}
                            rows={3}
                            maxLength={1000}
                            disabled={true}
                            data-testId="textbox3"
                            defaultValue={auditoriaSeleccionada?.RECHAZO}></textarea>

                          <span hidden={!isEdit}>{auditoriaSeleccionada?.RECHAZO.length}/1000</span>
                        </div>
                        <div className="row ajusteInput">
                          <div className="col-12">
                            <h6>
                              <span className="textSeccion">Usuario:</span>
                            </h6>
                          </div>
                          <div className="col-12">
                            <span>{auditoriaSeleccionada?.RESPONSABLE_AREA_DISPLAY}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    {isSendingData ? (
                      <Loading />
                    ) : (
                      <span>
                        {isEdit && (
                          <span>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary me-2"
                              onClick={async () => {
                                await saveData();
                              }}
                              disabled={isSendingData}>
                              Grabar
                            </button>

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary me-2"
                              onClick={async () => {
                                handleBtnContinuar();
                              }}
                              disabled={isSendingData}>
                              Continuar
                            </button>
                          </span>
                        )}
                        {auditoriaSeleccionada?.RESPONSABLE_AREA == currentUser?.email &&
                          auditoriaSeleccionada?.ID_ESTADO == EnumEstadoAuditoria.InformeListo && (
                            <span>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary me-2"
                                onClick={async () => {
                                  aprobacionAuditoria(true);
                                }}
                                disabled={isSendingData}>
                                Validar
                              </button>

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={async () => {
                                  MySwal.fire({
                                    html: (
                                      <div>
                                        <h4>Motivo del Rechazo:</h4>
                                      </div>
                                    ),
                                    input: "textarea",
                                    inputAttributes: {
                                      autocapitalize: "off",
                                    },
                                    showCancelButton: true,
                                    confirmButtonText: "Rechazar",
                                    cancelButtonText: "Cancelar",
                                    showLoaderOnConfirm: true,
                                    preConfirm: async (txtMotivo) => {
                                      if (!txtMotivo) {
                                        Swal.showValidationMessage(`Debe ingresar un motivo`);
                                      } else {
                                        await aprobacionAuditoria(false, txtMotivo);
                                        return true;
                                      }
                                    },
                                    allowOutsideClick: () => !Swal.isLoading(),
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      console.log("");
                                    }
                                  });
                                }}
                                disabled={isSendingData}
                                hidden={auditoriaSeleccionada.RECHAZO != null || false}>
                                Rechazar
                              </button>
                            </span>
                          )}

                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() => {
                            window.location.href = "/auditoria/home";
                          }}
                          disabled={isSendingData}>
                          <i className="bi bi-arrow-left-circle me-2"></i> Volver
                        </button>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
